import React from 'react';
import { Drawer, List } from '@material-ui/core';
import MicRoundedIcon from '@material-ui/icons/MicRounded';

import useShows from 'hooks/useShows';
import { ShowDb } from 'types';

import ShowPicker from './ShowPicker';
import useStyles from '../styles/Drawer';
import ListItemLink, { NavigationLink } from './ListItemLink';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const ShowDrawer: React.FC<Props> = (props) => {
  const { isOpen, onClose } = props;
  const classes = useStyles();
  const { shows, selectedShow, setSelectedShow } = useShows();

  const showsLinks = shows.map((show: ShowDb) => ({
    label: show.title,
    icon: <MicRoundedIcon />,
    to: `/links/${show.vanityUrl}`,
    isActive: show.vanityUrl === selectedShow.vanityUrl,
    onClick: () => {
      onClose();
      setSelectedShow(show);
    },
  }));

  return (
    <Drawer
      open={isOpen}
      anchor="left"
      onClose={onClose}
      classes={{
        paper: classes.drawerPaper,
      }}
    >
      <ShowPicker isClickable={false} />
      <List className={classes.drawerContent}>
        {showsLinks.map((link: NavigationLink) => (
          <ListItemLink key={link.to} exact {...link} />
        ))}
      </List>
    </Drawer>
  );
};

export default ShowDrawer;
